import { Expand } from "@faire/slate-icons/Expand";
import { Minimize } from "@faire/slate-icons/Minimize";

import { COPY } from "../copy";

type ExpandCardButtonProps = {
  expanded: boolean;
  onClick: () => void;
};

/**
 * Layout toggle for a card that can take the full page width.
 *
 * Icon-only, unlike the underlined text buttons in these same header slots
 * ("Edit store types", "Explore all conversions"). Those act on the content;
 * this one only changes how much room the card gets, so it reads as chrome
 * beside the title rather than as another thing to go and do. The label rides
 * along as `aria-label` and as a native tooltip, so it stays reachable.
 */
export function ExpandCardButton({ expanded, onClick }: ExpandCardButtonProps) {
  const label = expanded
    ? COPY.customers.storeTypeCards.collapse
    : COPY.customers.storeTypeCards.expand;

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={label}
      aria-expanded={expanded}
      title={label}
      className="-my-1 shrink-0 rounded p-1 text-[#757575] transition-colors hover:bg-[#f2f2f2] hover:text-[#333] focus-visible:ring-2 focus-visible:ring-[#333] focus-visible:outline-none"
    >
      {expanded ? (
        <Minimize width="16" height="16" color="currentColor" titleAccess="" />
      ) : (
        <Expand width="16" height="16" color="currentColor" titleAccess="" />
      )}
    </button>
  );
}
